<template>
  <div class="pms-search-bar">
    <slot />
    <div class="search-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PmsSearchBar',
};
</script>

<style lang="scss" scoped>
.pms-search-bar {
  display: grid;
  gap: 8px 9px;
  align-items: center;
  grid-auto-flow: row;
}

/* 1550px 屏幕：一行 4 个元素，日期占 2 个元素 */
@media (max-width: 1550px) {
  .pms-search-bar {
    grid-template-columns: repeat(4, 1fr);
  }
  
  /* 包含日期范围选择器的 PmsSearchItem 占 2 列 */
  /deep/ .pms-search-item:has(.el-date-editor--daterange),
  /deep/ .pms-search-item:has(.el-date-editor--datetimerange) {
    grid-column: span 2;
  }
  
  /* 普通 PmsSearchItem 占 1 列 */
  /deep/ .pms-search-item:not(:has(.el-date-editor--daterange)):not(:has(.el-date-editor--datetimerange)) {
    grid-column: span 1;
  }
  
  /* 日期范围选择器宽度 */
  /deep/ .el-date-editor--daterange,
  /deep/ .el-date-editor--datetimerange {
    width: 100%;
    min-width: 380px;
  }
}

/* 1920px 屏幕：固定列数，保持选择框宽度 */
@media (min-width: 1890px) {
  .pms-search-bar {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }
  
  /* 包含日期范围选择器的 PmsSearchItem 占 2 列 */
  /deep/ .pms-search-item:has(.el-date-editor--daterange),
  /deep/ .pms-search-item:has(.el-date-editor--datetimerange) {
    grid-column: span 2;
  }
  
  /* 普通 PmsSearchItem 占 1 列 */
  /deep/ .pms-search-item:not(:has(.el-date-editor--daterange)):not(:has(.el-date-editor--datetimerange)) {
    grid-column: span 1;
  }
  
  /* 日期范围选择器宽度 */
  /deep/ .el-date-editor--daterange,
  /deep/ .el-date-editor--datetimerange {
    width: 100%;
    min-width: 400px;
  }
  
  /* 普通选择器宽度 */
  /deep/ .el-select,
  /deep/ .el-input {
    width: 100%;
    min-width: 200px;
  }
}

/* 让 actions 永远在"尾行最后一格" */
.search-actions {
  grid-column: -2 / -1;  /* 关键：最后一列 */
  justify-self: end;     /* 右对齐 */
  display: flex;
  gap: 12px;
  white-space: nowrap;   /* 避免按钮自己换行 */
}

/* 普通选择器限制最大宽度，确保内容显示完整 */
/deep/ .el-select {
  width: 100%;
}

/* 输入框样式 */
/deep/ .el-input__inner {
  padding: 0 15px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s;
}

/* 日期选择器输入框样式，确保文本不遮挡图标 */
/deep/ .el-date-editor .el-input__inner {
  padding-left: 50px;
}

/deep/ .el-input__inner:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

/* 选择器样式 */
/deep/ .el-select .el-input__inner {
  padding-right: 30px;
}

/* 日期范围选择器分隔符样式 */
/deep/ .el-date-editor--daterange .el-range-separator {
  align-self: center !important;
  margin: 0 8px;
  color: #606266;
  font-size: 14px;
  line-height: 36px !important;
  vertical-align: middle !important;
}

/* 确保日期选择器内部元素垂直居中 */
/deep/ .el-date-editor--daterange {
  display: flex !important;
  align-items: center !important;
}

/deep/ .el-date-editor--daterange .el-range-input {
  align-self: center !important;
}

/* 按钮样式 */
/deep/ .el-button {
  border-radius: 4px;
  transition: all 0.3s;
}

/deep/ .el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}

/deep/ .el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

/deep/ .el-button--default {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #606266;
}

/deep/ .el-button--default:hover {
  border-color: #409eff;
  color: #409eff;
}
</style>
